import React from 'react';
import Member from "../../models/Member";
import {Avatar, Grid} from "@mui/material";
import {ellipsis} from "../../utils/strings";

interface VoterIconProps {
    member: Member;
}

export const VoterIcon: React.FC<VoterIconProps> = ({member}) => {
    return (
        <>
            <Grid item>
                <Avatar src={member.profileImage} sx={{width: 40, height: 40}}/>
            </Grid>
            <Grid item textAlign={"center"}>
                <span style={{fontSize: "9px"}}>{ellipsis(member.name, 8)}</span>
            </Grid>
        </>
    )
}